import { useScopedI18n } from '@/locales/client'

const PageHeader = () => {
  const t = useScopedI18n('pageHeader')
  return (
    <div className="mt-4 text-center *:text-pretty md:my-6">
      <h1 className="break-keep font-inter text-3xl font-bold leading-loose md:text-4xl">
        {t('title')}
      </h1>
      <p className="hidden font-inter text-xl font-medium leading-loose md:block">
        {t('subtitle')}
      </p>
    </div>
  )
}

export default PageHeader
